<template>
  <div id="app">
    <div class="left-cover"></div>
    <div class="right-cover"></div>
    <div class="page-header">
      <screen-header />
    </div>
    <div class="page-content">
      <router-view />
    </div>
    <div class="page-footer"></div>
  </div>
</template>

<script>
import screenHeader from '@/module/header/index.vue';

export default {
  components: {
    screenHeader,
  },
};
</script>

<style lang="less">
@import "@/assets/style/normalize.css";
@import "@/assets/style/global.less";

#app {
  @headerHeight: 80px;
  @footerHeight: 56px;

  width: 100vw;
  height: 1080px;
  // background-color: rgba(6, 15, 40, 1);
  background-color: rgba(10, 17, 37, 1);
  position: relative;
  .left-cover {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 600px;
    height: 100%;
    opacity: 0.6;
    background-image: url('@/assets/images/leftCover.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .right-cover {
    z-index: 1;
    position: absolute;
    top: 0;
    right: 0;
    width: 600px;
    height: 100%;
    opacity: 0.6;
    background-image: url('@/assets/images/rightCover.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .page-header {
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
  }
  .page-content {
    height: calc(1080px - @headerHeight - @footerHeight);
    padding-top: @headerHeight;
  }
  .page-footer {
    width: 100vw;
    height: @footerHeight;
    background-image: url('@/assets/images/backgroundBottom.png');
    background-repeat: no-repeat;
    background-position: center center;
  }
}
</style>
